/**
 * How a rate's amount reads, matching the tariff editor: PERCENT is stored as a fraction and shown
 * ×100 with "%", DOLLAR gets "$", PLAIN (counts such as minutes or MPG) is the bare number.
 */
export const RATE_UNITS = { DOLLAR: 'DOLLAR', PERCENT: 'PERCENT', PLAIN: 'PLAIN' };

/** The rate filter's "everything" option. */
export const ALL_RATES = { key: 'ALL', label: 'All rates' };

/** Rate categories that aren't a service level or a tariff grid section, in the order they're listed. */
export const RATE_CATEGORIES = {
    SERVICES: { key: 'SERVICES', label: 'Services' },
    ACCESSORIALS: { key: 'ACCESSORIALS', label: 'Accessorials' },
    CUSTOM_ACCESSORIALS: { key: 'CUSTOM_ACCESSORIALS', label: 'Custom Accessorials' },
    FUEL: { key: 'FUEL', label: 'Fuel' },
    OTHER: { key: 'OTHER', label: 'Other' },
};
